export default "__VITE_ASSET__BvbitIah__"